import ReducerUtils         from "../../../utils/ReducerUtils"
import Actions              from "../../../model/constant/actions"

const handleError = (state,action) => {
  return {...state ,
    [action.accountId] : {
      ...(state[action.accountId]||{}),
      status:action.status,
      message:action.message
    }
  }
}
const failedRetrievingAdGroupConfigs = ReducerUtils.createReducer({},{
  [Actions.FAILED_RETRIEVING_AD_GROUP_CONFIG] : handleError
})

export default failedRetrievingAdGroupConfigs
